import React from 'react';
import { useSelector } from 'react-redux';

// Components

import ApplyingForHealthCoverageSummary from '@components/ssap/pages/pageIncludes/summary/ApplyingForHealthCoverageSummary';
import PageHeader from '@components/ssap/headers/PageHeader';
import SummaryFilter from '@components/ssap/pages/pageIncludes/summary/SummaryFilter';
import ValidationErrorMessage from '@components/ssap/notifications/ValidationErrorMessage';

// Selectors

import {
    selectBloodRelationships,
    selectHouseholdMembers,
    selectNonSeekingForCoverageAndEnrolled,
    selectRelations
} from '@reducers/appReducer';

// Constants

import { VALIDATION_ERROR_MESSAGES } from '@constants/inputs/validationErrorMessages';

// Types

import { SsapSummaryType } from '@components/ssap/SsapTypes';

const HouseholdCommonSummary = props => {

    const { exchangeName, indexMapper } = props;

    const bloodRelationship = useSelector(selectBloodRelationships);
    const householdMembers = useSelector(selectHouseholdMembers);
    const nonSeekingForCoverageAndEnrolled = useSelector(selectNonSeekingForCoverageAndEnrolled);
    const relations = useSelector(selectRelations);

    const isAtLeastOneEnrolled = nonSeekingForCoverageAndEnrolled.length > 0;

    return (
        <SummaryFilter summaryId = { SsapSummaryType.HOUSEHOLD_COMMON } indexMapper = { indexMapper } >
            <div className = 'final-review-heading' >
                <PageHeader
                    text = 'ssap.subheader.applying_for_health_coverage'
                    headerClassName = 'gi-heading-alt'
                />
            </div>

            <ValidationErrorMessage
                isVisible = { isAtLeastOneEnrolled }
                messageText = { VALIDATION_ERROR_MESSAGES.AT_LEAST_ONE_APPLICANT_ENROLLED }
                messageTextReplacements = { { exchangeName } }
                errorClasses={ [ 'margin-l-0', 'margin-b-10', 'width-full' ] }
            />

            <div className = 'final-review-body break_after' >
                <ApplyingForHealthCoverageSummary
                    { ...{
                        bloodRelationship,
                        householdMembers,
                        relations
                    } }
                />
            </div>
        </SummaryFilter>
    );
};

export default HouseholdCommonSummary;